export async function copyToClipboard(copyValue: string) {
  return navigator.clipboard.writeText(copyValue)
}
